export enum Activity {
	student,
	employed,
	supportedWork,
	leave,
	unemployed,
	paternityservice,
	retired,
	other
};

export type ActivityKeys = keyof typeof Activity;